import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
//import { isLandscape } from '../../../assets/scripts/utilities/media-queries.js'
import extractMicrioUrlParts from '../../../assets/scripts/utilities/extract-micrio-url-parts.js'

const dataUrlTEMP = id => `https://b.micr.io/${id}/data.en.json`

const getObjectWithTour = async objects => {
  let id
  let tour

  for (const object of objects) {
    const urlParts = extractMicrioUrlParts(object.linkHref)

    if (!urlParts.objectId) {
      continue
    }

    const result = await fetch(dataUrlTEMP(urlParts.objectId)).then(response => response.ok && response.json())

    if (result?.markerTours?.length && result.markerTours[1]) {
      id = urlParts.objectId
      tour = result
      break
    }
  }

  //const result = results.filter(result => result?.markerTours?.length && result.markerTours[1])[0]
  //const tour = result.markerTours[1]

  return { id, tour }
}

class LandingThemesComponent extends Component {
  init() {
    this.preTitle = this.element.getAttribute('data-pre-title') || ''

    window.addEventListener('micrio-data', async event => await this.initAfterData(event?.detail?.themes?.items || []))
  }

  async initAfterData(themes = []) {
    const template = this.element.querySelector('.landing-themes__template')

    themes = themes.filter(({ title, objects }) => title && objects)

    if (!template || !themes.length) {
      return
    }

    for (const theme of themes) {
      const { title, slug, objects } = theme
      await this.createTheme(template, title, slug, objects)
    }
  }

  async createTheme(template, title, slug, objects) {
    if (!template || !slug || !title) {
      return
    }

    const clone = template.content.cloneNode(true)
    const theme = clone.querySelector('.landing-themes__theme')
    const buttonBack = clone.querySelector('.button--back')

    theme.id = slug
    objects = objects.filter(object => object.imageSrc && object.linkHref && object.title)
    objects.length ? await this.createObjects(clone, objects) : theme.querySelector('.landing-themes__theme-objects').remove()
    buttonBack?.addEventListener('click', event => this.onButtonBackClick(event))

    window.addEventListener('open-theme-overlay', event => {
      if (event.detail !== slug) {
        return
      }

      document.querySelectorAll('.landing-themes__theme--active').forEach(element => element.classList.remove('landing-themes__theme--active'))
      theme.classList.toggle('landing-themes__theme--active', event.detail === slug)

      const buttonTheme = document.querySelector('.theme-bar__button[href="#' + slug + '"]')
      document.querySelectorAll('.theme-bar__button--active').forEach(element => element.classList.remove('theme-bar__button--active'))
      buttonTheme?.classList.toggle('theme-bar__button--active', event.detail === slug)
    })

    this.element.appendChild(clone)
  }

  async createObjects(clone, objects) {
    if (!clone || !objects.length) {
      return
    }

    const theme = clone.querySelector('.landing-themes__theme')
    const elementObjects1 = theme.querySelector('.landing-themes__theme-objects')
    const elementObjects2 = theme.querySelector('.landing-themes__theme-objects + .landing-themes__theme-objects')
    const template = this.element.querySelector('.landing-themes__object-template')

    if (!theme || !elementObjects1 || !elementObjects2 || !template) {
      return
    }

    objects = objects.filter(object => object.title && object.linkHref && object.imageSrc)

    const tourObject = (await getObjectWithTour(objects)) || null
    //const tour = tourObject?.markerTours?.length > 1 ? tourObject.markerTours[1] : null
    window.tourStepIndexesTEMP = {}

    objects.forEach(({ title, linkHref, imageSrc }, index) => {
      const clone2 = template.content.cloneNode(true)

      const elementLink = clone2.querySelector('.image-stamp')
      const elementImage = clone2.querySelector('.image-stamp__image')
      const elementTitle = clone2.querySelector('.landing-themes__theme-object-title')

      if (tourObject.id) {
        const objectId = extractMicrioUrlParts(linkHref).objectId
        window.tourStepIndexesTEMP[objectId] = { index, id: tourObject.id }
      }

      elementLink.href = linkHref // tourObject.id ? `https://i.micr.io/${tourObject.id}/en/` : linkHref
      elementImage.src = imageSrc
      elementImage.alt = title || ''
      elementTitle.innerText = title

      //if (index % 2) { // Alternate
      if (index < objects.length / 2) {
        elementObjects1.appendChild(clone2)
      } else {
        elementObjects2.appendChild(clone2)
      }
    })
  }

  resetCursor(cursor) {
    if (!cursor) {
      return
    }

    cursor.classList.add('cursor--visible')
    cursor.style.position = 'relative'
    cursor.style.top = 'unset'
    cursor.style.left = 'unset'
    cursor.style.transform = 'unset'
  }

  onButtonBackClick(event = {}) {
    event?.preventDefault()

    document.querySelectorAll('.landing-themes__theme--active').forEach(element => element.classList.remove('landing-themes__theme--active'))
    document.querySelectorAll('.theme-bar__button--active').forEach(element => element.classList.remove('theme-bar__button--active'))
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'landing-themes', LandingThemesComponent))
